;(function ($) {


  var $searchbarToggle = $(),
      $searchbarRow = $();


  /**
   * Source: js/superfish/supposition.js
   */
  function _offset (dir) {
    return window[dir == 'y' ? 'pageYOffset' : 'pageXOffset']
    || document.documentElement && document.documentElement[dir=='y' ? 'scrollTop' : 'scrollLeft']
    || document.body[dir=='y' ? 'scrollTop' : 'scrollLeft'];
  }


  /**
   * Toggle searchbar
   */
  function setSearchbarVisible (toggle) {
    if (toggle) {
      $searchbarRow.removeClass('navbar-search-toggle-hidden')
      $searchbarRow.css('height', '');
      $('input', $searchbarRow).focus();
    } else {
      $searchbarRow.addClass('navbar-search-toggle-hidden');
      $searchbarRow.css('height', 0);
    }
  }


  /**
   * On document ready
   */
  $(function () {
    $('#superfish-main').on('mouseover', 'li.menuparent', function () {
      var $subMenu = $(this).children('ul').first();
      var $self = $(this);

      setTimeout(function () {
        $.each($subMenu.find('li.menuparent'), function () {
          var menuParentWidth = $(this).closest('li').outerWidth(true);
          var menuParentLeft = $(this).closest('li').offset().left;

          var offsetLeft = $(this).offset().left;
          var width = $(this).outerWidth(true);
          var totalRight = $(window).width() + _offset('x');
          var opensSideways = offsetLeft + width * 2 > totalRight && menuParentLeft > width;

          if ($(this).hasClass('opens-sideways')) {
            opensSideways = true;
          }

          /**
           * Show arrow left
           */
          var menuWidth = $(this).width();
          var menuRight = $(this).offset().left + menuWidth;
          var exactMenuWidth = (menuRight > (menuParentWidth + menuParentLeft)) ? menuWidth - (menuRight - (menuParentWidth + menuParentLeft)) : menuWidth;
          var level = $(this).parents('ul').length;

          if (menuRight + exactMenuWidth  > totalRight && level <= 3) {
            $(this).addClass("arrow_left");
          }

          $(this).toggleClass('opens-sideways', opensSideways);
        });
      }, 50);
    });

    $searchbarToggle = $('.navbar-search-toggle');
    $searchbarRow = $('.nav-mobile-searchbar');

    setSearchbarVisible(false);

    $searchbarToggle.click(function () {
      var searchbarIsHidden = $searchbarRow.hasClass('navbar-search-toggle-hidden');
      setSearchbarVisible(searchbarIsHidden);
    });

  });

}(jQuery));
